import {forwardRef} from 'react'
import _ from 'lodash'
import {Colors} from '@eitje/assets'
import {Layout} from '../layout'
import {Icon} from '../icon'
import {Popout} from '../popout'

export const withInfoIconMessage = Component => {
	return forwardRef(({infoIconMessage, ...rest}, ref) => {
		if (_.isEmpty(infoIconMessage)) return <Component ref={ref} {...rest} />

		const props = _.isString(infoIconMessage) ? {tooltip: infoIconMessage} : infoIconMessage
		return (
			<Layout className="text-info-icon-message-container">
				<Component ref={ref} {...rest} />
				<InfoIconMessage {...props} />
			</Layout>
		)
	})
}

export const InfoIconMessage = ({icon = 'question-mark', type, tooltip, ...rest}) => {
	if (tooltip) return <InfoIcon icon={icon} tooltip={tooltip} />

	return <Popout type={type} triggerEvent="hover" {...rest} trigger={<InfoIcon icon={icon} />} />
}

const ICON_SIZE = 14

const InfoIcon = forwardRef(({icon, tooltip}, ref) => {
	const layoutProps = ICON_LAYOUT_PROPS[icon]
	if (icon === 'question-mark-grey') icon = 'question-mark'

	return (
		<Layout
			className="info-icon"
			ref={ref}
			borderRadius="7"
			width={ICON_SIZE}
			height={ICON_SIZE}
			colorSet={false}
			{...layoutProps}
			tooltip={tooltip}
		>
			<Icon name={icon} fill={Colors.white} size={ICON_SIZE} />
		</Layout>
	)
})

const ICON_LAYOUT_PROPS = {
	'exclamation-mark': {
		background: 'medium-red',
	},
	'question-mark': {
		background: 'medium-pink',
	},
	'question-mark-grey': {
		background: 'medium-grey',
	},
}
